import React from "react";
import { Container } from "@mui/material";

const CustomContainer = ({
  children,
  maxWidth = false,
  width = "100%",
  ...props
}) => {
  return (
    <Container
      disableGutters
      maxWidth={maxWidth}
      sx={{
        maxWidth: width || (maxWidth === false ? "100%" : undefined),
        mx: "auto",
        ...props.sx,
      }}
      {...props}
    >
      {children}
    </Container>
  );
};

export default CustomContainer;
